import {
  initialState,
  Actions,
  State,
  NEW_ENROLLMENT,
  NEW_ENROLLMENT_SUCCESS,
  NEW_ENROLLMENT_ERROR,
  RESET_NEW_ENROLLMENT,
} from "../../types/enrollment/new.dto";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_ENROLLMENT:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          success: false,
          error: false,
        },
      };
    case NEW_ENROLLMENT_SUCCESS:
      return {
        ...state,
        data: JSON.parse(JSON.stringify(action.payload)),
        states: {
          loading: false,
          success: true,
          error: false,
        },
      };
    case NEW_ENROLLMENT_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          success: false,
          error: action.payload,
        },
      };
    case RESET_NEW_ENROLLMENT:
      return initialState
    default:
      return { ...state };
  }
};

export default reducers;
